import { RouterProvider } from 'react-router-dom';

// project import
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// for date-pickers throughout the project
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { AppProvider } from 'contexts/AppContext';
import { SuggestionsProvider } from 'contexts/SuggestionsContext';
import { RightPanelProvider } from 'contexts/RightPanelContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <AuthProvider>
                <AppProvider>
                  <SuggestionsProvider>
                    <RightPanelProvider>
                      <Notistack>
                        <RouterProvider router={router} />
                        <Snackbar />
                      </Notistack>
                    </RightPanelProvider>
                  </SuggestionsProvider>
                </AppProvider>
              </AuthProvider>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </LocalizationProvider>
    </ThemeCustomization>
  );
}
